// eslint-disable-next-line import/no-cycle
import { Location } from '../types'
import apiRequest from './request'

const internalApi = process.env.NEXT_PUBLIC_INTERNAL_API_URL

export const defaultLocationsMap = (location: Location) => ({
  ...location,
  lat: location.lat?.toString() || null,
  lon: location.lon?.toString() || null
})

export const getLocationsWithChildren = async (locale: string) => {
  const response = await apiRequest(`${internalApi}/${locale}/api/filters/locations/tree`)
  return response.json()
}
